<template>
<!-- Site wrapper -->
<div class="wrapper">
  <cabecalho tituloPagina="Galeria de fotos" />
  <menuLateral />

  <!-- Content Wrapper. Contains page content -->
  <div class="content-wrapper">
    <!-- Content Header (Page header) -->
    <section class="content-header">
      <div class="container-fluid">
      </div><!-- /.container-fluid -->
    </section>
    <!-- Main content -->
    <section class="content">
      <div class="card">
        <div class="card-body">
          <div v-if="flagsDeControle.carregandoDados.status" class="d-flex align-items-center">
            <span class="avisoDanger">{{flagsDeControle.carregandoDados.mensagem}}</span>
            <b-spinner class="ml-2" variant="danger"></b-spinner>
          </div>
          <div class="row">
            <div class="col-12 col-sm-12 col-md-12">
              <div class="card bg-light d-flex flex-fill">
                <div class="card-header border-bottom-0">
                  <h4 class="card-title titulos-conteudo">{{album.title}}</h4>
                </div>
                <div class="card-body pt-0">
                  <div class="row">
                    <div class="col-12">
                      <p class="text-muted text-justify text-md">{{album.description}}</p>
                    </div>
                    <div class="col-12">
                      <small class="text-muted">Publicado por: <strong>{{publicador}}</strong> em: {{dataHoraFormatada}}</small>
                    </div>
                    <div class="row">
                      <div v-for="(foto) in listaFotosAlbum" :key="foto.id" class="col-8 col-sm-6 col-md-3">
                        <div class="card bg-light d-flex flex-fill mt-2 mr-2 text-center">
                          <div class="card-header titulos-conteudo border-bottom-0"></div>
                          <div class="card-body pt-0">
                            <div class="row">
                              <div class="col-12 ">
                                <imageStream class="img-fluid mb-2" :imageStream="foto.image_file_name" alt="Foto" />
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div><!-- end row -->
                  </div>
                </div>
                <div class="card-footer text-right">
                  <b-button class="botoes" variant="outline-primary btn-sm" @click="voltarRotaAnterior()" :disabled="flagsDeControle.carregandoDados.status">Cancelar</b-button>
                </div>
              </div>
            </div>
          </div><!--  fim row -->
        </div><!-- /.card-body -->
      </div><!-- /.card -->
    </section><!-- /.content -->
  </div><!-- /.content-wrapper -->
</div><!-- ./wrapper -->
</template>

<script>
import GaleriaFotos from './js/detalhes-galeriaFotos'
export default GaleriaFotos
</script>

<style scoped>
@import "./scss/galeriaFotos.scss";
</style>
